import { z } from 'zod';

/**
 * Phone schema (legacy name kept for import compatibility — used by sign-in / OTP).
 * No country restriction: accepts any international number with 7–15 digits
 * (Georgian +995, Russian +7, etc.). Messages are in English (server fallback);
 * the frontend may still override via a zodResolver errorMap for i18n.
 */
export const russianPhoneSchema = z
    .string()
    .min(1, 'Enter your phone number')
    .transform(str => str.replace(/\D/g, ''))
    .refine(digits => digits.length >= 7 && digits.length <= 15, {
        message: 'Enter a valid phone number',
    })
    .transform(digits => `+${digits}`);
